import { ErrorField } from '@mairistem/liste';
import type { LigneMouvement } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../../constants/mouvements/naturePiece';
import NATURE_PIECE_ORIGINE from '../../../../constants/mouvements/naturePieceOrigine';
import { TYPE_BORDEREAU } from '../../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../../constants/mouvements/typePiece';
import AdmissionEnNonValeurPanel from '../../panel/InformationsRattachement/AdmissionEnNonValeurPanel';
import BaseProfilRattachement from '../Base/BaseProfilRattachement';

class ProfilEcritureAdmissionsNonValeurDepense extends BaseProfilRattachement {
  constructor(anneeExercice: number) {
    super();
    this.code = PROFIL_ECRITURE.DEPENSE.ADMISSIONS_NON_VALEUR;
    this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.DEPENSE.FONCTIONNEMENT;
    this.typePiece = TYPE_PIECE.DEPENSE.ADMISSION_NON_VALEURS;
    this.naturePieceOrigine = NATURE_PIECE_ORIGINE.MANDAT.LISTE_NON_VALEUR.CODE;
    this.idLigneOriginePes = 0;
    this.exerRattachement = anneeExercice?.toString();
    this.panels = [
      new AdmissionEnNonValeurPanel(true),
    ];
    this.imputation.articles = ['6541', '6542'];
    this.modeDeReglement = [MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE];
  }

  checkLigne(ligne: LigneMouvement): ErrorField[] {
    const errors: ErrorField[] = [];

    errors.push(...super.checkLigne(ligne));

    if (parseInt(ligne.exerRattachement, 10) > parseInt(this.exerRattachement, 10)) {
      errors.push({
        id: 'mouvement-exerRattachement',
        message: "L'exercice de rattachement doit correspondre à un exercice antérieur ou égal à celui du mouvement",
      });
    }

    if (Number(ligne.pieceOrigine) < 1) {
      errors.push({
        id: `ligneMouvement-idPieceOrigine-${ligne?.identifiant}`,
        message: "L'identifiant de la pièce d'origine doit être supérieur ou égal à 1",
      });
    }

    if (ligne.idLigneOriginePes !== 0) {
      errors.push({
        id: `ligneMouvement-idLigneOriginePes-${ligne?.identifiant}`,
        message: "L'identifiant de la ligne d'origine PES doit être égal à 0",
      });
    }

    return errors;
  }
}

export default ProfilEcritureAdmissionsNonValeurDepense;
